module.exports = __webpack_public_path__ + "static/img/ewm.48d67c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/inform/ewm.png
// module id = 6Wvf
// module chunks = 1